import { ApolloServerError } from "../../types/ApolloServerError";
import { PortexServerError } from "../../types/PortexServerError";

export function isNotAuthorizedError(e: unknown): e is ApolloServerError {
  const error = e as PortexServerError;

  return error.message === "Not Authorized";
}
